module.exports = __webpack_public_path__ + "static/media/zyla-logo.50cb0a43.svg";